import { postServiceInquiry } from "./service-inquiry";

interface ServiceInquirySuccessResponse {
  success: true;
  data: unknown;
}

interface ServiceInquiryErrorResponse {
  success: false;
  error: string;
}

/**
 * Service Inquiry POST handler for requests to a Next.js API endpoint
 * @param request - The incoming HTTP request
 * @returns A Response object with success/error status and data
 */
export async function serviceInquiryPostHandler(
  request: Request,
): Promise<Response> {
  try {
    // const decodedCookieData = await getTrackingCookie();
    const formData = await request.json();

    const data = await postServiceInquiry({
      ...formData,
      // TrackingCookie: decodedCookieData,
    });

    const successResponse: ServiceInquirySuccessResponse = {
      data,
      success: true,
    };
    return Response.json(successResponse);
  } catch (error) {
    let errorMessage = "Unknown error occurred";

    if (error instanceof Error) {
      errorMessage = error.message;
    }

    const errorResponse: ServiceInquiryErrorResponse = {
      error: errorMessage,
      success: false,
    };

    return Response.json(errorResponse, { status: 500 });
  }
}
